import { render, staticRenderFns } from "./EinvoiceAdjustmentDraftBadge.vue?vue&type=template&id=9038d608&scoped=true"
import script from "./EinvoiceAdjustmentDraftBadge.vue?vue&type=script&lang=js"
export * from "./EinvoiceAdjustmentDraftBadge.vue?vue&type=script&lang=js"
import style0 from "./EinvoiceAdjustmentDraftBadge.vue?vue&type=style&index=0&id=9038d608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9038d608",
  null
  
)

export default component.exports